<template>
    <div>
        <inner-page-banner-component></inner-page-banner-component>

        <main class="privacy-policy ptb100">

            <div class="section-title">
                <h2>Privacy Policy</h2>
            </div>

            <div class="col-md-12 terms">
                <p>It is CryoHost Zimbabwe's policy to respect your privacy regarding any information we may collect
                    while operating our website. This Privacy Policy applies to <a href="https://cryo.host">https://cryo.host</a>
                    (hereinafter, "us", "we", or "https://cryo.host"). We respect your privacy and are committed to
                    protecting personally identifiable information you may provide us through the Website. We have
                    adopted this privacy policy ("Privacy Policy") to explain what information may be collected on our
                    Website, how we use this information, and under what circumstances we may disclose the information
                    to third parties. This Privacy Policy applies only to information we collect through the Website and
                    does not apply to our collection of information from other sources.</p>
                <p>This Privacy Policy, together with the Terms and conditions posted on our Website, set forth the
                    general rules and policies governing your use of our Website. Depending on your activities when
                    visiting our Website, you may be required to agree to additional terms and conditions.</p>

                <h3>Website Visitors</h3>
                <p>Like most website operators, CryoHost Zimbabwe collects non-personally-identifying information of the
                    sort that web browsers and servers typically make available, such as the browser type, language
                    preference, referring site, and the date and time of each visitor request. CryoHost Zimbabwe's
                    purpose in collecting non-personally identifying information is to better understand how CryoHost
                    Zimbabwe's visitors use its website. From time to time, CryoHost Zimbabwe may release
                    non-personally-identifying information in the aggregate, e.g., by publishing a report on trends in
                    the usage of its website.</p>
                <p>CryoHost Zimbabwe also collects potentially personally-identifying information like Internet Protocol
                    (IP) addresses for logged in users and for users leaving comments on https://cryo.host blog posts.
                    CryoHost Zimbabwe only discloses logged in user and commenter IP addresses under the same
                    circumstances that it uses and discloses personally-identifying information as described below.</p>

                <h3>Gathering of Personally-Identifying Information</h3>
                <p>Certain visitors to CryoHost Zimbabwe's websites choose to interact with CryoHost Zimbabwe in ways
                    that require CryoHost Zimbabwe to gather personally-identifying information. The amount and type of
                    information that CryoHost Zimbabwe gathers depends on the nature of the interaction. For example, we
                    ask visitors who sign up for a blog at https://cryo.host to provide a username and email
                    address.</p>

                <h3>Security</h3>
                <p>The security of your Personal Information is important to us, but remember that no method of
                    transmission over the Internet, or method of electronic storage is 100% secure. While we strive to
                    use commercially acceptable means to protect your Personal Information, we cannot guarantee its
                    absolute security.</p>

                <h3>Advertisements</h3>
                <p>Ads appearing on our website may be delivered to users by advertising partners, who may set cookies.
                    These cookies allow the ad server to recognize your computer each time they send you an online
                    advertisement to compile information about you or others who use your computer. This information
                    allows ad networks to, among other things, deliver targeted advertisements that they believe will be
                    of most interest to you. This Privacy Policy covers the use of cookies by CryoHost Zimbabwe and does
                    not cover the use of cookies by any advertisers.</p>


                <h3>Links To External Sites</h3>
                <p>Our Service may contain links to external sites that are not operated by us. If you click on a third
                    party link, you will be directed to that third party's site. We strongly advise you to review the
                    Privacy Policy and terms and conditions of every site you visit.</p>
                <p>We have no control over, and assume no responsibility for the content, privacy policies or practices
                    of any third party sites, products or services.</p>


                <h3>Protection of Certain Personally-Identifying Information</h3>
                <p>CryoHost Zimbabwe discloses potentially personally-identifying and personally-identifying information
                    only to those of its employees, contractors and affiliated organizations that (i) need to know that
                    information in order to process it on CryoHost Zimbabwe's behalf or to provide services available at
                    CryoHost Zimbabwe's website, and (ii) that have agreed not to disclose it to others. Some of those
                    employees, contractors and affiliated organizations may be located outside of your home country; by
                    using CryoHost Zimbabwe's website, you consent to the transfer of such information to them. CryoHost
                    Zimbabwe will not rent or sell potentially personally-identifying and personally-identifying
                    information to anyone. Other than to its employees, contractors and affiliated organizations, as
                    described above, CryoHost Zimbabwe discloses potentially personally-identifying and
                    personally-identifying information only in response to a subpoena, court order or other governmental
                    request, or when CryoHost Zimbabwe believes in good faith that disclosure is reasonably necessary to
                    protect the property or rights of CryoHost Zimbabwe, third parties or the public at large.</p>
                <p>If you are a registered user of https://cryo.host and have supplied your email address, CryoHost
                    Zimbabwe may occasionally send you an email to tell you about new features, solicit your feedback,
                    or just keep you up to date with what's going on with CryoHost Zimbabwe and our products. We
                    primarily use our blog to communicate this type of information, so we expect to keep this type of
                    email to a minimum. If you send us a request (for example via a support email or via one of our
                    feedback mechanisms), we reserve the right to publish it in order to help us clarify or respond to
                    your request or to help us support other users. CryoHost Zimbabwe takes all measures reasonably
                    necessary to protect against the unauthorized access, use, alteration or destruction of potentially
                    personally-identifying and personally-identifying information.</p>

                <h3>Aggregated Statistics</h3>
                <p>CryoHost Zimbabwe may collect statistics about the behavior of visitors to its website. CryoHost
                    Zimbabwe may display this information publicly or provide it to others. However, CryoHost Zimbabwe
                    does not disclose your personally-identifying information.</p>


                <h3>Cookies</h3>
                <p>To enrich and perfect your online experience, CryoHost Zimbabwe uses "Cookies", similar technologies
                    and services provided by others to display personalized content, appropriate advertising and store
                    your preferences on your computer.</p>
                <p>A cookie is a string of information that a website stores on a visitor's computer, and that the
                    visitor's browser provides to the website each time the visitor returns. CryoHost Zimbabwe uses
                    cookies to help CryoHost Zimbabwe identify and track visitors, their usage of https://cryo.host, and
                    their website access preferences. CryoHost Zimbabwe visitors who do not wish to have cookies placed
                    on their computers should set their browsers to refuse cookies before using CryoHost Zimbabwe's
                    websites, with the drawback that certain features of CryoHost Zimbabwe's websites may not function
                    properly without the aid of cookies.</p>
                <p>By continuing to navigate our website without changing your cookie settings, you hereby acknowledge
                    and agree to CryoHost Zimbabwe's use of cookies.</p>

                <h3>E-commerce</h3>
                <p>Those who engage in transactions with CryoHost Zimbabwe – by purchasing CryoHost Zimbabwe's services
                    or products, are asked to provide additional information, including as necessary the personal and
                    financial information required to process those transactions. In each case, CryoHost Zimbabwe
                    collects such information only insofar as is necessary or appropriate to fulfill the purpose of the
                    visitor's interaction with CryoHost Zimbabwe. CryoHost Zimbabwe does not disclose
                    personally-identifying information other than as described below. And visitors can always refuse to
                    supply personally-identifying information, with the caveat that it may prevent them from engaging in
                    certain website-related activities.</p>

                <h3>Business Transfers</h3>
                <p>If CryoHost Zimbabwe, or substantially all of its assets, were acquired, or in the unlikely event
                    that CryoHost Zimbabwe goes out of business or enters bankruptcy, user information would be one of
                    the assets that is transferred or acquired by a third party. You acknowledge that such transfers may
                    occur, and that any acquirer of CryoHost Zimbabwe may continue to use your personal information as
                    set forth in this policy.</p>

                <h3>Privacy Policy Changes</h3>
                <p>Although most changes are likely to be minor, CryoHost Zimbabwe may change its Privacy Policy from
                    time to time, and in CryoHost Zimbabwe's sole discretion. CryoHost Zimbabwe encourages visitors to
                    frequently check this page for any changes to its Privacy Policy. Your continued use of this site
                    after any change in this Privacy Policy will constitute your acceptance of such change.</p>


                <h3></h3>
                <p></p>

                <h3>Contact Information</h3>
                <p>
                    If you have any questions about this Privacy Policy, please contact us via <a
                        href="mailto:legal@alcra.co.zw">email</a> or <a href="tel:08644989204">phone</a>.</p>
            </div>

        </main>

        <div class="clearfix ptb20"></div>
        <footer-component></footer-component>
    </div>
</template>


<script>
    export default {
        name: "ContactComponent",
        mounted() {
            // eslint-disable-next-line no-undef
            jQuery('.terms h3').uppercaseWords()
        }
    }
</script>

<style lang="scss">
    .terms {
        padding: 0 50px;
        text-align: center;

        h3 {
            text-transform: capitalize;
            font-weight: bold;
            color: #222;
        }
    }
</style>